import { createEffect, createEvent, createStore } from 'effector';
import { format } from 'date-fns';
import FileSaver from 'file-saver';
import type { Payload } from './export-template.types';

export const fxExportTemplate = createEffect<Payload, Blob | MediaSource, Error>();
export const fxDownloadFile = createEffect<[Blob | MediaSource, string], void, Error>(
  (response) => {
    const [result, title]: [result: Blob | MediaSource, title: string] = response;
    const blob = new Blob([result], {
      type: 'application/octet-stream',
    });

    const dateTimeNow = format(new Date(), 'dd.MM.yyyy-HH.mm.ss');
    FileSaver.saveAs(blob, `${title}-${dateTimeNow}.xlsx`);
  }
);

export const exportTemplate = createEvent<void>();
export const $isLoading = createStore<boolean>(false);
